/**
 * Sorts persons array with primary persons first
 * @param {Array} persons - Array of person objects
 * @returns {Array} Sorted array with primary persons first
 */
export const sortPersonsByPrimary = (persons) => {
  return persons.toSorted((a, b) => {
    if (a.primary === true && b.primary !== true) return -1
    if (b.primary === true && a.primary !== true) return 1
    return 0
  })
}
